import React, { useCallback } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import Loading from '../../components/common/Loading'
import { eClaimDetail } from '../../constant/path'
import { useScreen } from '../../utils/responsive-helper'
import { useRouter } from '../../utils/helper'
import { useGetEClaimHistoryById, useCancelEClaim } from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType, ClaimDocumentTypes } from '../../services/e-claim/e-claim-types'
import EClaimInfo from './EClaimInfo'
import EClaimForm from '../EClaimDetail/EClaimForm'
import { useMemo } from 'react'
import dayjs from 'dayjs'
import moment from 'moment'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { setClaimInfo } from '../../redux-store/e-claim-reducer'
import config from '../../config'

export type InitialValueType = {
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  relativeTypeId: string
  receiptDate: string
  claimName: string
}

const EClaimHistoryDetail = () => {
  const { query } = useRouter<{ id: number }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { mutate: cancelEClaim } = useCancelEClaim()
  const { data: eClaimItem, isLoading } = useGetEClaimHistoryById({ id: query.id })
  const {
    claim,
    userClaimDocumentList,
    userClaimAmount,
    userClaimAmountApprove,
    relativeId,
    slipDate,
  } = eClaimItem || {}

  const initialValue = useMemo(() => {
    return {
      name: claim?.name || '',
      amountReceipt: userClaimAmount,
      amountClaim: userClaimAmountApprove,
      receiptFile: `${config.apiHost}/files${userClaimDocumentList?.filter(item => item.documentType.name === FileType.ReceiptFile)[0]?.filePath || ''}`,
      optionalFileUrl: `${config.apiHost}/files${userClaimDocumentList?.filter(item => item.documentType.name === FileType.OptionalFileUrl)[0]?.filePath || ''}`,
      relativeTypeId: relativeId ? relativeId.toString() : '',
      receiptDate: slipDate,
      claimName: claim?.name || '',
    }
  }, [claim, userClaimAmount, userClaimAmountApprove, userClaimDocumentList, relativeId, slipDate])

  const disable = useMemo(() => {
    if (!eClaimItem?.approved && (eClaimItem?.approved !== null)) {
      return false
    } else {
      return true
    }
  }, [eClaimItem?.approved])

  const onCreateNewEClaim = useCallback(async () => {
    if (eClaimItem?.id === undefined) return

    let receiptFile: string = ''
    let optionalFileUrl: string = ''

    if (eClaimItem.userClaimDocumentList.filter(item => item.documentType.name === FileType.ReceiptFile).length > 0) {
      receiptFile = `${config.apiHost}/files${eClaimItem.userClaimDocumentList[0].filePath}`
    }
    if (eClaimItem.userClaimDocumentList.filter(item => item.documentType.name === FileType.OptionalFileUrl).length > 0) {
      optionalFileUrl = `${config.apiHost}/files${eClaimItem.userClaimDocumentList[1].filePath}`
    }

    dispatch(
      setClaimInfo({
        name: eClaimItem.claim.name || '',
        amountReceipt: eClaimItem.userClaimAmount,
        amountClaim: eClaimItem.userClaimAmountApprove,
        receiptFile,
        optionalFileUrl,
        relativeTypeId: eClaimItem.relativeId ? eClaimItem.relativeId.toString() : '',
        receiptDate: eClaimItem.slipDate,
        claimName: eClaimItem.claim.name || '',
      }),
    )

    history.push(eClaimDetail({
      routeParam: {
        eClaimId: eClaimItem?.claimId
      },
      queryParam: {
        isCreateNew: 'true'
      }
    }))
  }, [eClaimItem, history, dispatch])

  if (!eClaimItem) return null

  return (
    <Loading loading={isLoading}>
      <div style={{ paddingTop: '24px' }}>
        <Headbar title={eClaimItem?.claim.name || ''} backWard={paths.eClaimHistory()} />
        <EClaimInfo id={query.id} eClaimItem={eClaimItem} onCreateNewEClaim={onCreateNewEClaim} />
        <EClaimForm
          eClaimItem={eClaimItem}
          eClaimId={eClaimItem.claimId}
          // eClaimItem={initialValue}
          // initialValues={eClaimItem?.claim}
          initialValues={initialValue}
          allpayStatus={disable}
          isHistory={true}
          editable={false}
        />
      </div>
    </Loading>
  )
}

export default EClaimHistoryDetail
